module.exports = __webpack_public_path__ + "first-10_signature.jpg?d8e7f09f5affb6801119999e69b5514b";


//////////////////
// WEBPACK FOOTER
// ./src/assets/features/first-10_signature.jpg
// module id = 449
// module chunks = 0